<template>
  <UiModal fullheight smallgrey @close="$emit('close')">
    <div class="promo-modal-wrapper">
      <div class="header">Скидки магазина {{ shop.name }}</div>
      <ul v-if="!loading && list?.length" class="cards">
        <LazyModalsPromocodeShopModalPromoShopItem
          v-for="(item, i) in list"
          :key="i"
          :item="item"
        />
      </ul>
      <div v-if="loading" class="loader">Загрузка...</div>
      <div v-if="!loading && !list?.length" class="loader">
        Активных промокодов не найдено
      </div>
      <nuxt-link
        v-if="shop.coupons_slug"
        :to="'/' + shop.coupons_slug + '/'"
        class="all-promo"
      >
        Все скидки магазина
      </nuxt-link>
      <div class="ord">Реклама, {{ shopname }}</div>
    </div>
  </UiModal>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import { useGlobalStore } from '~/stores/global';
import { API } from '@/api/api';
const props = defineProps({
  shop: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
});
const globalStore = useGlobalStore();
const list = ref([]);
const shopname = computed(() => props.shop.site.replace(/https?:\/\//g, ''));
const loading = ref(false);
onMounted(async () => {
  loading.value = true;
  try {
    const shop_id = props.shop?.id;
    const model_id = props.model?.id;
    const res = await API.get(`/shops/${shop_id}/coupons/models/${model_id}`, {
      params: { region_id: globalStore.region?.id },
    });
    list.value = res.data.list;
  } catch (err) {
  } finally {
    loading.value = false;
  }
});
</script>
<style lang="scss" scoped>
.promo-modal-wrapper {
  height: var(--fullvh);
  width: 100%;
  margin: auto;
  padding: 20px 16px 16px;
  display: grid;
  grid-template-rows: max-content auto max-content max-content;
  @include xl-block {
    height: 100%;
    max-height: 80vh;
    max-width: 437px;
  }

  .header {
    @include fz(20, 28);
    font-weight: 600;
    margin-bottom: 16px;
    padding-right: 20px;
  }

  .cards,
  .loader {
    max-height: calc(100vh - 144px);
    height: 100%;
    overflow-y: auto;
    grid-gap: 12px;
    display: grid;
    align-content: start;
    padding-right: 8px;

    @include xl-block {
      max-height: calc(80vh - 144px);
      padding-right: 0;
    }
  }

  .loader {
    @include fz(16, 24);
    color: $achromatic-disabled;
  }

  .all-promo {
    @include fz(14, 20);
    font-weight: 500;
    margin-top: 14px;
    margin-bottom: 14px;
    color: $main-cta;
    text-align: center;
    text-decoration: none;
  }

  .ord {
    @include fz(12, 16);
    color: $achromatic-disabled;
    text-align: center;
  }
}
</style>
